import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Space, Spin, Col } from "antd";
import OTPInput from "otp-input-react";
import { useTranslation } from "react-i18next";
import { postRequest } from "../axios";
import { SuccessNotificationMsg } from "../utils/Notifications";
import { loadingIcon } from "../utils/Helper";
import PropTypes from "prop-types";
const PhoneOtpVerify = ({ handleCancelPhone, OTP, setOTP, state, setState, seconds, setSeconds, minutes, setMinutes, handleSendOtpPhone, setVerificationResultContact, setVerifyPhoneButtonView }) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const [apiLoading, setApiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const initialState =
  {
    phone_number: state.phone ? state.phone : null,
    phone_number_otp: OTP,
  }

  const [verifyState, setVerifyState] = useState(initialState);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const apiResponse = await postRequest("verified-otp/phone-number-otp-verifed/", verifyState);
      console.log("apiiiiiiiiPhonenn", apiResponse);
      if (apiResponse.data.success) {
        setVerificationResultContact('success');
        setVerifyPhoneButtonView(false);
        SuccessNotificationMsg("Verified Successfully");
        setState((prevState) => ({
          ...prevState,
          phone_verified: true,
        }));
        setVerifyState(initialState);
        handleCancelPhone();
      }
    } catch (error) {
      console.error(error);
      setVerificationResultContact('');
      setState((prevState) => ({
        ...prevState,
        phone_verified: false,
      }));
      handleCancelPhone();
      setVerifyPhoneButtonView(true);
    } finally {
      setBtnLoading(false);
    }
  };
  const handleOtpChange = (value) => {
    setOTP(value)
    setVerifyState((prevState) => ({
      ...prevState,
      phone_number: state.phone ? state.phone : null,
      phone_number_otp: value,
    }));
  };
  const handelResendClick = async () => {
    setOTP(null);
    handleSendOtpPhone()
  };

  return (
    <Spin spinning={apiLoading} indicator={loadingIcon}>
      <Form onFinish={handleSubmit} ref={formRef}>

        <label>
          OTP has been sent on {state.phone}
        </label>


        <div className="modelotp">
          <div className="Otp-Input-Box">
            <OTPInput
              value={OTP}
              onChange={(value) => handleOtpChange(value)}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
            />
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={btnLoading}
            className="GradiantBtn mt-2"
          >
            {t("verify")}
          </Button>

          <Col className="VerifyOTP-Options mt-2">
            <Space>
              {seconds > 0 || minutes > 0 ? (
                <p style={{ margin: 0 }}>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p style={{ margin: 0 }}>{t("didnotreceived")}</p>
              )}
              <Button
                type="link"
                onClick={handelResendClick}
                loading={apiLoading}
                style={{ color: seconds > 0 || minutes > 0 ? "GrayText" : "#094E8F" }}
                disabled={seconds > 0 || minutes > 0}
                danger
              >
                {t("resendOTP")}
              </Button>
            </Space>
          </Col>
        </div>
      </Form>
    </Spin>
  );
};

PhoneOtpVerify.propTypes = {


  id: PropTypes.func.isRequired,
  handleCancelPhone: PropTypes.func.isRequired,
  OTP: PropTypes.func.isRequired,
  setOTP: PropTypes.func.isRequired,
  onClose: PropTypes.number,
  visible: PropTypes.bool,
  state: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  setMinutes: PropTypes.func.isRequired,
  setSeconds: PropTypes.func.isRequired,
  seconds: PropTypes.func.isRequired,
  minutes: PropTypes.func.isRequired,
  handleSendOtpPhone: PropTypes.func.isRequired,
  setVerificationResultContact: PropTypes.func.isRequired,
  setVerifyPhoneButtonView: PropTypes.func.isRequired,


};
export default PhoneOtpVerify;
